import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import leaderboardData from "./json/npsalltimeranking/leaderboard.json"
import PrivacyPloicy from "./pages/PrivacyPolicyNew/PrivacyPloicy";
import NewFaq from "./pages/NewFaq/NewFaq";
import Faq from "./pages/Faq/Faq";
import Legal from "./pages/Faq/Legal";
import Tnc from "./pages/Faq/Tnc";
import PrivacyPolicy from "./pages/Faq/PrivacyPolicy";
import GeneralQueries, { BaaziSelectMembership, BaaziStore, GameplayQueries, LeaderboardAndProgression, TaskRewards, TechnicalQueries, Wallet } from "./pages/Faq/GeneralQueries";
import Rewardpoints from "./pages/Faq/Rewardpoints";

const pages = [
  "PokerSchoolComingSoon", "Howtoplay", "Howtoplay2", "Howtoplaynewuser",
  "Howtoplaypokerpartnerapp", "Howtoplayplaycircle",
  "Flash", "HowTournamentWork", "LeaderBoard", "Satelite", "PfsVideos",
  "PokerSchool", "TestingHeader", "TestingNoHeader",
  "MonsoonCarnival", "BaaziTurbo", "Baazi1000x", "IndianPokerMasters",
  "IndianPokerMastersBackup", "EndBoss",
  "Imps", "SuperHoldem", "CoinsDetail", "FtdBonus", "MoneyMaker", "MissionMarathon",
  "Goatold", "PokerGo", "Shahid", "ShahidNew", "Mythbuster", "SitandGo", "SitandGoMCE",
  "PloVideos", "DepositWithdrawFaq", "BaaziValueSeries", "Anniversary9th", "FreeEntry",
  "FaqGst", "Classics", "Tschedule", "NpsBootCamp",
  "Bss", "PokerBaazi4", "CashBattleRoyale6", "Aptindia",
  "Allinfold", "Helpdesk", "MobileAppPaymentSuccess", "OfcRewardFaq", "BaaziMillions",
  "FaqGuestPreLogin", "FaqDeposit", "MasterClass", "RakeWork", "PowerSaving"


].reduce((acc, page) => {
  acc[page] = React.lazy(() => import(`./pages/${page}`));
  return acc;
}, {});

const Promotions = React.lazy(() => import("./Promotions"));
const Homepage = React.lazy(() => import("./dsite/pages/Homepage"));
const VietnamScoreCard = React.lazy(() => import("./pages/VietnamTournamentPage/VietnamScoreCard"));
const Fairplay = React.lazy(() => import("./pages/FairplayPage/Fairplay"));
const Allinclub = React.lazy(() => import("./pages/AllinclubPage/Allinclub"));
const Anniversary10th = React.lazy(() => import("./pages/Anniversary10th/Anniversary10th"));
const Series1000x = React.lazy(() => import("./pages/Series1000xPage/Series1000x"));
const Cashanniversary = React.lazy(() => import("./pages/CashanniversaryPage/Cashanniversary"));
const Wintercashcarnival = React.lazy(() => import("./pages/WintercashcarnivalPage/Wintercashcarnival"));
const Newyearcashcarnival = React.lazy(() => import("./pages/NewyearcashcarnivalPage/Newyearcashcarnival"));
const Springcashcarnival = React.lazy(() => import("./pages/SpringcashcarnivalPage/Springcashcarnival"));
const Summercashcarnival = React.lazy(() => import("./pages/SummercashcarnivalPage/Summercashcarnival"));
const Anniversarycarnival = React.lazy(() => import("./pages/AnniversarycarnivalPage/Anniversarycarnival"));

const Bombpot = React.lazy(() => import("./pages/BombpotPage/Bombpot"));
const Wpt = React.lazy(() => import("./pages/WPTPage/WPT"));
const TeamPro = React.lazy(() => import("./pages/TeamProPage/TeamPro"));
const Nps = React.lazy(() => import("./pages/NpsSeries/Nps"));
const NpsTnc = React.lazy(() => import("./pages/NpsSeries/NpsTnc"));
const NpsLeaderboard = React.lazy(() => import("./pages/NpsSeries/NpsLeaderboard"));
const NpsSchedule = React.lazy(() => import("./pages/NpsSeries//NpsSchedule"));
const NpChampion = React.lazy(() => import("./pages/NpsSeries/NpChampion"));
const NpsInfo = React.lazy(() => import("./pages/NpsSeries/NpsInfo"));
const Npctnc = React.lazy(() => import("./pages/NpsSeries/Npctnc"));
const HowItWorksNpc = React.lazy(() => import("./pages/NpsSeries/HowItWorksNpc"));
const HowItWorksNpcDsite = React.lazy(() => import("./dsite/pages/HowItWorksNpc/HowItWorksNpcDsite"));

const Roadtonps = React.lazy(() => import("./pages/RoadToNpsPage/RoadToNps"));
const PlayerOfTheYear = React.lazy(() => import("./pages/PlayeroftheyearPage/PlayerOfTheYear"));
const TncPoy = React.lazy(() => import("./pages/PlayeroftheyearPage/TncPoy"));
const TncAllinclub = React.lazy(() => import("./pages/AllinclubPage/TncAllinclub"));
const Npscamp = React.lazy(() => import("./pages/NpsCampPage/Npscamp"));
const NpsAllTimeRanking = React.lazy(() => import("./pages/NpsAllTimeRankingPage/NpsAllTimeRanking"));
const PlayerDetails = React.lazy(() => import("./pages/NpsAllTimeRankingPage/PlayerDetails"));
const Mytickets = React.lazy(() => import("./pages/MyticketsPage/Mytickets"));
const Thecircuit = React.lazy(() => import("./pages/ThecircuitPage/Thecircuit"));
const Productupdate = React.lazy(() => import("./pages/ProductupdatePage/Productupdate"));
const Whatisplo = React.lazy(() => import("./pages/WhatisploPage/Whatisplo"));
const Goatnew = React.lazy(() => import("./pages/GoatPage/Goat"));
const TDSPolicy = React.lazy(() => import("./pages/TdsPolicyPage/TDSPolicy"));


export default function AllRouting() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="text-centered"></div>}>
        <Routes>
          {Object.entries(pages).map(([name, Component]) => (
            <Route key={name} path={`/${name.toLowerCase()}`} element={<Component />} />
          ))}
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/" element={<Promotions />} />
          <Route path="/vietnamscorecard" element={<VietnamScoreCard />} />
          <Route path="/fairplay" element={<Fairplay />} />
          <Route path="/allinclub" element={<Allinclub />} />
          <Route path="/mytickets" element={<Mytickets />} />
          <Route path="/thecircuit" element={<Thecircuit />} />
          <Route path="/productupdates" element={<Productupdate />} />
          <Route path="/whatisplo" element={<Whatisplo />} />
          <Route path="/goat" element={<Goatnew/>} />
          <Route path="/anniversary10th" element={<Anniversary10th />} />
          <Route path="/series1000x" element={<Series1000x />} />
          <Route path="/cash-anniversary" element={<Cashanniversary />} />
          <Route path="/wintercashcarnival" element={<Wintercashcarnival />} />
          <Route path="/newyearcashcarnival" element={<Newyearcashcarnival />} />
          <Route path="/springcashcarnival" element={<Springcashcarnival />} />
          <Route path="/summercashcarnival" element={<Summercashcarnival />} />
          <Route path="/anniversarycashcarnival" element={<Anniversarycarnival/>} />
          <Route path="/bombpot" element={<Bombpot />} />
          <Route path="/wpt" element={<Wpt />} />
          <Route path="/teampro" element={<TeamPro />} />
          <Route path="/nps" element={<Nps />} />
          <Route path="/npstnc" element={<NpsTnc />} />
          <Route path="/npsleaderboard" element={<NpsLeaderboard />} />
          <Route path="/npsschedule" element={<NpsSchedule />} />
          <Route path="/npchampion" element={<NpChampion />} />
          <Route path="/npsinfo" element={<NpsInfo />} />
          <Route path="/npctnc" element={<Npctnc />} />
          <Route path="/howitworksnpc" element={<HowItWorksNpc />} />
          <Route path="/howitworksnpcdsite" element={<HowItWorksNpcDsite />} />

          <Route path="/roadtonps" element={<Roadtonps />} />
          <Route path="/playeroftheyear" element={<PlayerOfTheYear />} />
          <Route path="/tncpoy" element={<TncPoy />} />
          <Route path="/allinclub/tnc" element={<TncAllinclub />} />
          <Route path="/npscamp" element={<Npscamp />} />
          <Route path="/npsalltimeranking" element={<NpsAllTimeRanking />} />
          <Route path="/tdspolicy" element={<Navigate to="/tds-free-april" replace />} />
          <Route path="/tds-free-april" element={<TDSPolicy />} />
          <Route path="/ftp-privacy-policy" element={<PrivacyPloicy/> } />
           <Route path="/faq" element={<NewFaq/> } />
            <Route path="/faqs" element={<Faq/> } />
            <Route path="/faqs/legality" element={<Legal/> } />
            <Route path="/faqs/tnc" element={<Tnc/> } />
             <Route path="/faqs/privacy-policy" element={<PrivacyPolicy/>} />
             <Route path="/faqs/general-queries" element={<GeneralQueries/>} />
              <Route path="/faqs/rewards-points" element={<Rewardpoints/>} />
               <Route path="/faqs/leaderboard-and-progression" element={<LeaderboardAndProgression/>} />
               <Route path="/faqs/gameplay-queries" element={<GameplayQueries/>} />
               <Route path="/faqs/baazi-store" element={<BaaziStore/>} />
               <Route path="/faqs/baazi-select-membership" element={<BaaziSelectMembership/>} />
               <Route path="/faqs/task-rewards" element={<TaskRewards/>} />
                <Route path="/faqs/technical-queries" element={<TechnicalQueries/>} />
                 <Route path="/faqs/wallet" element={<Wallet/>} />
          {/* <Route path="/playerdetails" element={<PlayerDetails/>} /> */}
          {/* <Route path="/" element={<NpsAllTimeRanking/>} /> */}
          {leaderboardData.map((index) => (
            <Route key={index} path={`/npsalltimeranking/:fullName`} element={<PlayerDetails />} />
          ))}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

